<section class="login-page">
  <mat-card class="login-card">
    <div class="login-copy">
      <p class="eyebrow">Admin Access</p>
      <h1>Create Admin Account</h1>
      <p class="subtitle">Register with a username and password to access the admin panel.</p>
    </div>

    <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Username</mat-label>
        <input matInput formControlName="username" placeholder="Enter username" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Password</mat-label>
        <input
          matInput
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          placeholder="Enter password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
          (click)="showPassword = !showPassword"
        >
          <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Confirm Password</mat-label>
        <input
          matInput
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirmPassword"
          placeholder="Confirm password"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          [attr.aria-label]="showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'"
          (click)="showConfirmPassword = !showConfirmPassword"
        >
          <mat-icon>{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      @if (registerError) {
      <p class="login-error">{{ registerError }}</p>
      }

      <button mat-raised-button color="primary" type="submit" [disabled]="isSubmitting">
        {{ isSubmitting ? 'Registering...' : 'Register' }}
      </button>
    </form>

    <p class="auth-link-row">
      Already have an account?
      <a routerLink="/login">Login</a>
    </p>
  </mat-card>
</section>
